import LogoSvg from 'assets/images/logo-diamond.svg'
import I18n from 'components/I18n'
import messages from 'lang'
import React from 'react'

import { Description, LogoWrapper, Title } from '../../LinkBank/styles'

type Props = {
  bankName: string
}

const WaitingFromBank = ({ bankName }: Props) => (
  <>
    <LogoWrapper>
      <img alt='Blockchain logo' src={LogoSvg} />
    </LogoWrapper>
    <Title>
      <I18n bankName={bankName} data={messages.waiting_bank_title} />
    </Title>
    <Description>
      <I18n data={messages.waiting_bank_subtitle} />
    </Description>
  </>
)

export default WaitingFromBank
